
export const Colors = {
    /// Figma 2.7 colors
    ec2bYellow: '#EEA141',
    ec2bRed: '#B23134',
    ec2bGreen: '#51A683',
    ec2bBeige: '#EEECEA',
    ec2bRed2: '#F6DFE0',
    onEc2bRed2: '#8C2629',
};